// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const RepairIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        d="M9.84 9.9c-.39-1.35-.35-2.77.11-4.1.35-1 1.17-2.14 2.02-2.8.48-.37 1.06-.68 1.6-.94 1.25-.6 3.08-.65 4.4-.2.24.08.52.22.63.47q.08.18.01.37c-.2.52-2.58 2.67-3.1 3.21-.15.16-.48.69-.64.76l-.07-.18c-.17.16-.1 2.14-.1 2.48.11-.02.23-.06.33-.01.07.11.04.22.02.36.4 0 1.97.06 2.25-.06l.07-.1c.89-.72 1.66-1.58 2.49-2.38.9-.86 2.07-2.55 2.5-.17.37 1.96.01 3.64-1.18 5.24-1 1.35-2.5 2.24-4.18 2.48-.35.05-.8.1-1.15.09-.58-.03-1.15-.15-1.71-.26q-.09 0-.16.07c-.8-.37-2.12-1.2-2.71-1.81-.4-.47-.72-1.02-1.04-1.54-.16-.25-.28-.62-.54-.75z"
        opacity=".5"
      />
      <path d="M9.7 10.13c.25.13.37.5.53.75.32.52.64 1.07 1.04 1.54.6.62 1.92 1.44 2.7 1.81-.88.63-1.73 1.69-2.55 2.44q-.2.19-.38.4-.93.88-1.84 1.79c-1.03 1-2 2.11-3.12 3-1.01.8-2.55.77-3.54-.06-.6-.5-.97-1.21-1.03-1.99-.09-1.11.44-1.95 1.2-2.71l1.51-1.49q1.27-1.28 2.57-2.54 1.32-1.3 2.62-2.63.15-.15.28-.31" />
    </g>
  </SvgIcon>
);

export default RepairIcon;
